<template>
  <treeselect
    class="iFilter__select"
    ref="industryRef"
    :multiple="true"
    :options="options"
    valueFormat="object"
    :disabled="disabled"
    @input="inputChange"
    v-model="selectedIndustries"
  />
</template>
<script>
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { getIndustry, industryAPI, resetStates, matchChildren } from "./utils";

export default {
  name: "industry-selector",

  components: {
    Treeselect
  },

  props: {
    industryType: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    initialVal: {
      type: String
    },
    recordId: {
      type: Number
    }
  },

  data() {
    return {
      selectedIndustries: [],
      industries: [],
      customIndustries: [],
      internalState: ''
    };
  },

  mounted() {
    this.$refs.industryRef.handleLocalSearch = this.handleLocalSearch;
    if (this.industryType) {
      this.loadIndustry();
    }
    this.setDefaultOptions();
  },

  computed: {
    options() {
      return [...this.industries, ...this.customIndustries];
    }
  },

  methods: {
    async handleLocalSearch() {
      const { industryRef } = this.$refs;
      const { searchQuery } = industryRef.trigger;
      const done = () => industryRef.resetHighlightedOptionWhenNecessary(true);

      if (!searchQuery || searchQuery.length < 3) {
        // Exit sync search mode.
        industryRef.localSearch.active = false;
        return done();
      }

      // Enter sync search mode.
      industryRef.localSearch.active = true;

      resetStates(industryRef);

      const lowerCasedSearchQuery = searchQuery.trim().toLocaleLowerCase();
      const normalizedOptions = industryRef.forest.normalizedOptions;
      try {
        const { body } = await industryAPI(
          this.industryType,
          lowerCasedSearchQuery
        );
        const resultsLength = matchChildren(normalizedOptions, body);
        if (resultsLength) industryRef.localSearch.noResults = false;
        done();
      } catch (e) {
        console.error(e);
      }
    },

    async loadIndustry() {
      try {
        this.industries = await getIndustry(this.industryType);
      } catch (e) {
        console.error(e);
      }
    },

    setDefaultOptions() {
      this.parseIndustries()
        .then(([industries, customIndustries]) => {
          this.customIndustries = customIndustries;
          this.selectedIndustries = industries;
        })
        .catch(e => {});
    },

    parseIndustries() {
      return new Promise(async (resolve, reject) => {
        if (!this.initialVal.length > 0) {
          reject();
        }
        // check if default value it's formated as treepicker or as a string
        const type = typeof this.initialVal;
        let industries = [];
        let searchList = [];
        switch (type) {
          case "string": {
            const values = new Set(
              this.initialVal.split("|").map(v => v.trim())
            );
            values.forEach(industry => {
              const id = industry.match(/\(([^)]+)\)/);
              if (!id) {
                searchList.push(industry); //Linkedin Industry
              } else {
                industries.push({
                  id: id[1],
                  label:
                    this.industryType === "linkedin"
                      ? industry.replace(id[0], "").trim()
                      : industry
                });
              }
            });
          }
          case "object": {
            break;
          }
          default:
            break;
        }

        const [coincidences, customIndustries] = await searchIndustries(
          searchList
        );
        industries = [...industries, ...coincidences, ...customIndustries];
        resolve([industries, customIndustries]);
      });
    },

    inputChange(value) {
        this.internalState = value.map(el => el.label).join(" | ");
        this.$emit("input",  this.internalState);
    }
  },

  watch: {
    async industryType(val) {
      this.loadIndustry();
      this.$refs.industryRef.clear();
    },

    recordId() {
      this.$refs.industryRef.clear();
      this.setDefaultOptions();
    },

    initialVal() {
        if(this.initialVal !== this.internalState) {
            this.setDefaultOptions();
        }
    }
  }
};

async function searchIndustries(searchList) {
  let matches = [];
  let list = searchList;
  if (!list.length) return [[], []];
  try {
    const { body } = await Vue.http.get("industries/?classification=linkedin");
    body.forEach(industry => {
      const index = list.indexOf(industry.title);
      if (index !== -1) {
        matches.push({
          id: industry.code,
          ...industry
        });
        list.splice(index, 1);
      }
    });
  } catch (e) {
    console.error(e);
  }
  return [
    matches,
    list.map(industry => ({
      id:
        industry +
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9),
      label: industry
    }))
  ];
}
</script>
<style>
.iFilter__select .vue-treeselect__input {
  padding: 0 !important;
  min-height: 0rem !important;
  border: none !important;
}
.iFilter__select .vue-treeselect__control {
  border-radius: 4px !important;
}

.iFilter__select .vue-treeselect__control-arrow-container {
  display: none;
}
.iFilter__select .vue-treeselect__multi-value-item {
  font-size: 12px !important;
}
.iFilter__select .vue-treeselect__placeholder,
.iFilter__select .vue-treeselect__single-value {
  line-height: 33px;
}
.iFilter__select .vue-treeselect__checkbox--checked {
  border-color: #ff578f;
  background-color: #ff578f;
}
.iFilter__select
  .vue-treeselect__option--highlight
  .vue-treeselect__checkbox--checked {
  border-color: #ff578f;
  background-color: #ff578f;
}
.iFilter__select .vue-treeselect__multi-value-item {
  background: #eeeeee;
  border: 1px solid #bebebe;
}
.iFilter__select .vue-treeselect__value-remove {
  border-left: 0;
}
.iFilter__select .vue-treeselect__value-remove,
.iFilter__select .vue-treeselect__multi-value-item {
  color: #3f3f3f;
}
.iFilter__select .vue-treeselect__label {
  display: table-cell !important;
}
</style>